export const getFileSizeFromBase64 = (
  base64: ArrayBuffer | string | undefined,
): number => {
  if (!base64) {
    return 0;
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return base64?.length * (3 / 4) - 2 || 0;
};
